import React from 'react'
import { Col, Row, Card } from 'react-bootstrap'
import { FaRobot, FaCheck, FaRocket } from 'react-icons/fa'
import { SectionTitle, StatCard, StatContent, StatIcon, StatInfo } from '../styles'

interface ModelStatisticsSectionProps {
  totalModels: number
  trainedModels: number
  deployedModels: number
}

const ModelStatisticsSection: React.FC<ModelStatisticsSectionProps> = ({
  totalModels,
  trainedModels,
  deployedModels,
}) => {
  return (
    <>
      <SectionTitle>
        <FaRobot /> Model Statistics
      </SectionTitle>
      <Row className="g-4">
        <Col lg={12} md={12} sm={4}>
          <StatCard $variant="purple">
            <Card.Body>
              <StatContent>
                <StatIcon>
                  <FaRobot />
                </StatIcon>
                <StatInfo>
                  <h3>{totalModels}</h3>
                  <p>Total Models</p>
                </StatInfo>
              </StatContent>
            </Card.Body>
          </StatCard>
        </Col>
        <Col lg={12} md={12} sm={4}>
          <StatCard $variant="success">
            <Card.Body>
              <StatContent>
                <StatIcon>
                  <FaCheck />
                </StatIcon>
                <StatInfo>
                  <h3>{trainedModels}</h3>
                  <p>Trained</p>
                </StatInfo>
              </StatContent>
            </Card.Body>
          </StatCard>
        </Col>
        <Col lg={12} md={12} sm={4}>
          <StatCard $variant="info">
            <Card.Body>
              <StatContent>
                <StatIcon>
                  <FaRocket />
                </StatIcon>
                <StatInfo>
                  <h3>{deployedModels}</h3>
                  <p>Deployed</p>
                </StatInfo>
              </StatContent>
            </Card.Body>
          </StatCard>
        </Col>
      </Row>
    </>
  )
}

export default ModelStatisticsSection
